"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JudgeRequest = void 0;
var JudgeRequest = /** @class */ (function () {
    function JudgeRequest() {
    }
    return JudgeRequest;
}());
exports.JudgeRequest = JudgeRequest;
;
//# sourceMappingURL=judge.request.js.map